module.exports = __webpack_public_path__ + "static/media/Promotion_Card_TH.023eaec3.jpg";